import { inject, Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FilterTextsPipe } from '../../pipes/filterTexts/filterTexts.pipe';
import {
  DEFAULT_LINK,
  ILink,
  INormalText,
  ERelationType,
  LinkId,
} from '@web/dtos';
import { ILinkForm } from '../../entities/link-entity';

@Injectable({
  providedIn: 'root',
})
export class LinkFormsFactoryService {
  formBuilder: FormBuilder = inject(FormBuilder);
  filterTexts: FilterTextsPipe = inject(FilterTextsPipe);

  buildFormArray(
    entity: ILink[] = [DEFAULT_LINK]
  ): FormArray<FormGroup<ILinkForm>> {
    return this.formBuilder.array<FormGroup<ILinkForm>>(
      entity.map((link: ILink, index: number): FormGroup<ILinkForm> => {
        return this.buildLinkFormGroup(link, index);
      })
    );
  }

  buildLinkFormGroup(
    link: ILink | undefined,
    position: number
  ): FormGroup<ILinkForm> {
    return this.formBuilder.group<ILinkForm>({
      id: this.formBuilder.control<LinkId | null>(link?.id || null),
      urls: this.formBuilder.nonNullable.control<INormalText[]>(
        this.filterTexts.transform(link?.texts ?? [], ERelationType.url)
      ),
      texts: this.formBuilder.nonNullable.control<INormalText[]>(
        this.filterTexts.transform(link?.texts ?? [], ERelationType.text) ?? []
      ),
      positionOrder: this.formBuilder.nonNullable.control(
        link?.positionOrder ?? position
      ),
    });
  }
}
